// extracted by mini-css-extract-plugin
export var fineprint = "share-module--fineprint--d90c1";
export var share = "share-module--share--36beb";